import React from "react";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import { useSelector } from "react-redux";
import { createServiceRequestByGroup } from "../../../../services/client";
import { toast } from "react-toastify";

export const GroupingModal = ({ serviceRequestIds, propertyId, existingGroups, onClose, fetchDashboard }) => {
  const [mode, setMode] = React.useState();

  switch (mode) {
    case "new":
      return <NewGroup serviceRequestIds={serviceRequestIds} onClose={onClose} fetchDashboard={fetchDashboard} />;
    case "existing":
      return <></>;
    default:
      return <ModeSelector mode={mode} setMode={setMode} />;
  }
};

const ModeSelector = ({ setMode }) => (
  <div
    style={{
      alignItems: "center",
      padding: 20,
      display: "flex",
      flexDirection: "column",
      gap: 10,
    }}
  >
    <Button
      color="teal"
      label="Create new group"
      size="tiny"
      onClick={() => setMode("new")}
    />
    <Button
      color="teal"
      label="Add to existing group"
      size="tiny"
      onClick={() => setMode("existing")}
    />
  </div>
);

const NewGroup = ({serviceRequestIds, propertyId, onClose, fetchDashboard }) => {
  const [groupName, setGroupName] = React.useState("");
  const auth = useSelector((state) => state.auth);
  const createGroup = () => {
    createServiceRequestByGroup({
      GroupName: groupName,
      PropertyId: propertyId,
      UserId: auth.user.id,
      ServiceRequest: serviceRequestIds.map((id) => ({ id })),
    }).then((res) => {
      if (res.status === 200) {
        toast.success("Group created successfully", {
          autoClose: 5000,
          position: "top-center",
        });
        onClose();
        fetchDashboard();
      } else {
        toast.error(
          "🚫 Failed to create group, please try again later.",
          { autoClose: 5000, position: "top-center" }
        );
      }
    }
    );
    onClose();
  }
  return (
    <>
      <Input
        value={groupName}
        onChange={(e) => setGroupName(e.target.value)}
        label="Group Name"
        placeholder="Enter Group Name .."
        block
        required
      />
      <Button
        color="teal"
        label="Create Group"
        size="small"
        onClick={() => {
          createGroup();
        }}
      />
    </>
  )
}
